import type { ColumnFiltersState } from '@tanstack/react-table';

export interface BuildFilterParamsOptions {
  fieldMapping?: Record<string, string>;
  staticParams?: Record<string, string>;
}

export function buildFilterParams(
  filters: ColumnFiltersState,
  options: BuildFilterParamsOptions = {},
): Record<string, string> {
  const { fieldMapping, staticParams } = options;
  const params: Record<string, string> = {};

  const makePattern = (raw: string, operator: string) => {
    switch (operator) {
      case 'contains':
        return `*${raw}*`;
      case 'startsWith':
        return `${raw}*`;
      case 'endsWith':
        return `*${raw}`;
      case 'gt':
        return `>${raw}`;
      case 'gte':
        return `>=${raw}`;
      case 'lt':
        return `<${raw}`;
      case 'lte':
        return `<=${raw}`;
      case 'isNull':
        return 'null';
      case 'isNotNull':
        return '!null';
      case 'not':
      case 'neq':
        return `!${raw}`;
      default:
        return raw;
    }
  };

  filters.forEach((cf) => {
    if (!cf?.id || !cf?.value) return;
    const { operator, value } = cf.value as {
      operator: string;
      value: unknown;
    };
    if (value == null || value === '') return;

    // TODO: Should we skip the filter if fieldMapping exists but doesn't have this key?
    // Currently we fall back to the default `filter[${cf.id}]`. Is that intentional?
    const key = fieldMapping?.[cf.id] ?? `filter[${cf.id}]`;

    const values = Array.isArray(value) ? value : [value];
    params[key] = values.map((v) => makePattern(String(v), operator)).join(',');
  });

  return { ...params, ...staticParams };
}
